<div [class.dash-shell]="!embedded()">
  @if (!embedded()) {
    <header class="page-head">
      <nav class="page-head__crumbs" aria-label="Breadcrumb">
        <a class="page-head__crumb" routerLink="/ops/dashboard">Ops</a>
        <span class="page-head__sep" aria-hidden="true">/</span>
        <span class="page-head__crumb page-head__crumb--current" aria-current="page"
          >DF Facilities Queue</span
        >
      </nav>
      <div class="page-head__bar">
        <div class="page-head__titles">
          <h1 class="page-head__title">Debtors Finance — Facilities</h1>
          <p class="page-head__subtitle">
            {{ facilityCount }} {{ statusFilterLabel() ? 'shown' : 'in queue' }}
          </p>
        </div>
        @if (statusFilterLabel(); as label) {
          <div class="page-head__actions">
            <button class="queue-filter-chip" type="button" (click)="clearFilter()">
              <span>Filtered: {{ label }}</span>
              <app-icon name="x-circle" [size]="14" />
            </button>
          </div>
        }
      </div>
    </header>
  } @else {
    <div class="queue-toolbar">
      <p class="queue-toolbar__count">
        {{ facilityCount }} {{ statusFilterLabel() ? 'shown' : 'in queue' }}
      </p>
      @if (statusFilterLabel(); as label) {
        <button class="queue-filter-chip" type="button" (click)="clearFilter()">
          <span>Filtered: {{ label }}</span>
          <app-icon name="x-circle" [size]="14" />
        </button>
      }
    </div>
  }

  @if (isLoading()) {
    <mat-card appearance="outlined" class="table-card" aria-label="Loading facilities">
      <table class="queue-table sg-table sg-table--skeleton" aria-hidden="true">
        <thead>
          <tr>
            <th>Business</th>
            <th>Requested limit</th>
            <th>AI recommendation</th>
            <th>Stage</th>
            <th>Submitted</th>
            <th>Dealt with by</th>
          </tr>
        </thead>
        <tbody>
          @for (r of [1, 2, 3, 4, 5]; track r) {
            <tr>
              <td><span class="sg-skeleton sg-skeleton--text sg-skeleton--w70"></span></td>
              <td><span class="sg-skeleton sg-skeleton--text" style="width: 55%"></span></td>
              <td><span class="sg-skeleton sg-skeleton--text sg-skeleton--w80"></span></td>
              <td><span class="sg-skeleton sg-skeleton--chip"></span></td>
              <td><span class="sg-skeleton sg-skeleton--text sg-skeleton--w60"></span></td>
              <td><span class="sg-skeleton sg-skeleton--text sg-skeleton--w50"></span></td>
            </tr>
          }
        </tbody>
      </table>
    </mat-card>
  } @else if (loadError()) {
    <div class="sg-empty sg-empty--bordered sg-empty--error">
      <app-icon name="x-circle" [size]="40" />
      <p class="sg-empty__title">Couldn't load facilities</p>
      <p class="sg-empty__desc">Something went wrong on our side.</p>
      <button mat-stroked-button type="button" (click)="load()">
        <app-icon name="refresh" [size]="18" /> Try again
      </button>
    </div>
  } @else if (facilityCount === 0) {
    <div class="sg-empty sg-empty--bordered">
      <app-icon name="document" [size]="40" />
      @if (statusFilterLabel(); as label) {
        <p class="sg-empty__title">No {{ label }} facilities</p>
        <p class="sg-empty__desc">No facilities match this filter right now.</p>
        <button mat-stroked-button type="button" (click)="clearFilter()">
          <app-icon name="restore" [size]="18" /> Clear filter
        </button>
      } @else {
        <p class="sg-empty__title">No facilities in queue yet</p>
        <p class="sg-empty__desc">Facility applications awaiting review will appear here.</p>
      }
    </div>
  } @else {
    <mat-card appearance="outlined" class="table-card">
      <table mat-table [dataSource]="dataSource" class="queue-table">
        <ng-container matColumnDef="entity">
          <th mat-header-cell *matHeaderCellDef>Business</th>
          <td mat-cell *matCellDef="let f">{{ f.entity_name }}</td>
        </ng-container>

        <ng-container matColumnDef="requested_limit">
          <th mat-header-cell *matHeaderCellDef>Requested limit</th>
          <td mat-cell *matCellDef="let f">{{ f.requested_limit | zar }}</td>
        </ng-container>

        <ng-container matColumnDef="ai_recommendation">
          <th mat-header-cell *matHeaderCellDef>AI recommendation</th>
          <td mat-cell *matCellDef="let f" class="ai-col">
            {{ aiRecLabel(f.latest_ai_recommendation) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="stage">
          <th mat-header-cell *matHeaderCellDef>Stage</th>
          <td mat-cell *matCellDef="let f">
            <app-status-chip [status]="f.application_stage" />
          </td>
        </ng-container>

        <ng-container matColumnDef="submitted">
          <th mat-header-cell *matHeaderCellDef>Submitted</th>
          <td mat-cell *matCellDef="let f">
            {{ f.submitted_at ? (f.submitted_at | date: 'mediumDate') : '—' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="assignee">
          <th mat-header-cell *matHeaderCellDef>Dealt with by</th>
          <td mat-cell *matCellDef="let f">
            @if (f.assignee_name) {
              {{ f.assignee_name }}
            } @else {
              <span class="queue-unassigned">Nobody</span>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr
          mat-row
          *matRowDef="let f; columns: columns"
          class="queue-table__row"
          [routerLink]="['/ops/df/facilities', f.short_id]"
        ></tr>
      </table>

      @if (dataSource.data.length > pageSizeOptions[0]) {
        <mat-paginator [pageSizeOptions]="pageSizeOptions" aria-label="Select page of facilities" />
      }
    </mat-card>
  }
</div>
